<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'500px'"
    :classDialog="'dialog-doc-out-finish'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #header>
      <h3 class="dialogTitle margin-left-10">
        Ký duyệt văn bản
      </h3>
    </template>

    <template #body>
      <div>
        <!--        <h3 class="dialogTitle">Ký duyệt văn bản</h3>-->
        <div class="has-border__bottom padding-bottom-10">
          <el-form ref="form" :model="form"  :rules="rules">
            <el-form-item
              label="Mật khẩu cấp 2"
              prop="hsmPassword2"
              v-if="vbStep.signType === 2 && userDeptRole.signType === 'hsm'"
            >
              <div style="display: flex; flex-direction: row">
                <el-input
                  v-model="form.hsmPassword2"
                  size="medium"
                  class="input-detail__editable style-fullWidth input-border__bottom input-border__radius__0"
                  maxlength="300"
                  :type="showPassword ? 'text' : 'password'"
                >
                </el-input>
                <div @click="togglePasswordVisibility">
                  <i :class="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="Ý kiến/đề xuất">
              <el-input
                v-model="form.content"
                type="textarea"
                placeholder="_"
                maxlength="400"
                show-word-limit
                :autosize="{ minRows: 5, maxRows: 7 }"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__between">
        <div class="flex-row flex__left">
          <em class="font-size__small">
            <span class="color__red">(*)</span> Xác nhận Ký duyệt văn bản</em
          >
        </div>
        <div class="flex-row flex__right form-button__action margin-top-10">
          <el-button
            type="success"
            size="mini"
            class="addDocs  color__white bg__blue btn-none__border"
            @click="banHanh"
            :disabled="isProcessing"
          >
            <i
              :class="[
                !isProcessing
                  ? 'fas fa-check-circle font-size__small'
                  : 'el-icon-loading'
              ]"
            ></i>
            &nbsp;Xác nhận
          </el-button>
        </div>
      </div>

      <docOutKetThucCTS
        :isOpen="isOpenDocOutKetThucDialog"
        @closeDialog="isOpenDocOutKetThucDialog = false"
        @dialogClosed="isEnableDocOutKetThucDialog = false"
        :dataCert="dataCert"
        @success="handleCertSelection"
      />
    </template>
  </custom-dialog>
</template>
<script>
import constants from "../../../constants";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import categoryService from "../../../services/categoryService";
import departmentService from "../../../services/departmentService";
import outgoingDocService from "../../../services/outgoingDocService";
import vbFlowService from "../../../services/vbFlowService";
import vbStepService from "../../../services/vbStepService";
import CustomDialog from "../../common/custom-dialog";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService";
import {EventBus} from "../../../event-bus.js";
import docOutDetailMixin from "../../../mixins/docOutDetailMixin";
import userService from "../../../services/userService";
import signingLocationUserService from "../../../services/signingLocationUserService";
import {save} from "./pdf-lib-utils/SignPdfKyDongTrinh";
import authenService from "../../../services/authenService";
import docOutKetThucCTS from "./DocOutKetThucCTS";

export default {
    name: "DocOutKetThuc",
    mixins: [handleRequestErrorMixin, docOutDetailMixin],
    props: ["isOpen", "vbOutgoingProcessId", "docId", "vbAttachmentId"],
    components: {CustomDialog, docOutKetThucCTS},

    computed: {
      parentRoute() {
        return this.$route.path.split("/")[3];
      },

      userDeptRole() {
        return this.$store.getters.userDeptRole;
      },

      isSignByUsbToken() {
        return this.userDeptRole.mobileSignerNetwork === 'mobifone' && this.userDeptRole.signType === 'usbtoken' && this.vbStep.signType === constants.STEP_INFO_SIGN_TYPE.KI_SO;
      },
      isConfigSigning() {
        return authenService.get(constants.GLOBAL_CONFIG.CONFIG_SIGNING) === "true"
      }
    },

    data() {
      return {
        isProcessing: false,
        form: {
          content: null,
          hsmPassword2: null,
        },
        showPassword: false,
        stepId: null,
        vbStep: null,
        vbOutgoingProcess: null,
        flowId: null,
        flow: null,
        publisher: null,
        vbOutgoingDoc: null,
        docTypeCode: null,
        isOpenDocOutKetThucDialog: false,
        isEnableDocOutKetThucDialog: false,
        serial_number: null,
        dataCert: [],
        rules: {
          hsmPassword2: [
            { required: true, message: "Mật khẩu cấp 2 không được phép bỏ trống", trigger: "blur" }
          ],
        },

      };
    },

    watch: {
      isOpenDocOutKetThucDialog(newValue) {
        newValue && (this.isEnableDocOutKetThucDialog = newValue);
      },
    },

    async created() {
      await this.loadVbOutgoingDoc();
      await this.loadPublisher();
      await this.initDocType();
      await this.loadVbOutgoingProcess();
      await this.loadVbStep();
      await this.loadFlow();
      this.initForm();
    },

    methods: {

      initDocType() {
        return (this.vbOutgoingDoc.docTypeCode
            ? Promise.resolve(this.vbOutgoingDoc.docTypeCode)
            : (this.vbOutgoingDoc.docTypeId
                ? categoryService
                  .findById(this.vbOutgoingDoc.docTypeId)
                  .then(response => response.data)
                : Promise.resolve(null)
            ).then(docType => (docType ? docType.categoryCode : null))
        ).then(docTypeCode => (this.docTypeCode = docTypeCode));
      },

      togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
      },

      loadPublisher() {
        return departmentService
          .findById(this.vbOutgoingDoc.publisherId)
          .then(response => (this.publisher = response.data));
      },

      loadVbOutgoingDoc() {
        return outgoingDocService
          .findById(this.docId)
          .then(response => (this.vbOutgoingDoc = response.data));
      },

      loadFlow() {
        return vbFlowService
          .findById(this.flowId)
          .then(response => (this.flow = response.data));
      },

      loadVbOutgoingProcess() {
        return vbOutgoingProcessService
          .findById(this.vbOutgoingProcessId)
          .then(response => {
            this.vbOutgoingProcess = response.data;
            this.stepId = this.vbOutgoingProcess.stepId;
          });
      },

      /**
       * 2. Trong TH ký duyệt cuối cùng:
       2.1: luồng đồng trinh: content = <null>
       2.2.1: trong TH văn bản là loại tờ trình (đơn vị ban hành là cấp phòng/ban): content = "Đồng ý"
       2.2.2: còn lại: content = <null>
       */
      initForm() {
        let content;
        if (
          this.flow &&
          this.flow.flowType !== constants.FLOW_TYPE.DONG_TRINH &&
          this.publisher.path !== this.userDeptRole.deptPath &&
          this.publisher.path.startsWith(this.userDeptRole.deptPath) &&
          this.docTypeCode === constants.CATEGORY.CODE.DOC_TYPE.TO_TRINH
        ) {
          console.log("123123");
          content = errorMessageFilter({
            errorCode: "vbOutgoingDoc.defaultSignContent"
          });
        } else {
          content = "";
        }
        this.form.content = content;
      },

      loadVbStep() {
        return vbStepService.findById(this.stepId).then(response => {
          this.vbStep = response.data;
          this.flowId = this.vbStep.flowId;
        });
      },

      async handleCertSelection(idSelection) {
        this.serial_number = idSelection.idSelection;
        await this.banHanh();
        this.isOpenDocOutKetThucDialog = false;
      },

      async banHanh() {
        if(this.userDeptRole.signType === 'rs' && this.userDeptRole.rmProvider !== 'remote_signing_ca') {
          if(!this.serial_number) {
            let submitFormCert = {
              userId : this.userDeptRole.rmTaxCode
            }

            try {
              await vbOutgoingProcessService
                .getCertificates(submitFormCert)
                .then(async response => {
                  let result = response.data;
                  this.dataCert = result.data;
                })
            } catch (error) {
              this.$notify.error({
                title: 'Lỗi',
                message: 'Ký số thất bại, vui lòng ký lại'
              });
            }

            if (this.dataCert && this.dataCert.length > 1) {
              this.isOpenDocOutKetThucDialog = true;
              return;
            } else if (this.dataCert && this.dataCert.length === 1) {
              this.serial_number = this.dataCert[0].serial_number
            } else {
              // popup bao loi
              return;
            }
          }
        }

        let submitForm = {
          outgoingProcessId: this.vbOutgoingProcessId,
          serialNumberRs: this.serial_number,
          content: this.form.content,
          vbAttachmentId: this.vbAttachmentId
        };

        if (this.isSignByUsbToken) {
          // Thực hiện ký số bằng usb token
          await this.signVbWithoutTokenImages(this.docId)
            .then(response => {
              console.log('response after sign:', response)
              let signResult = response.data;
              if (signResult.Status === constants.TOKEN_CA.STATUS.SUCCESS) {
                // Thêm 1 số tham số cho submitForm
                submitForm.isSignByUsbToken = this.isSignByUsbToken;
                submitForm.base64 = signResult.FileDataSigned;
                submitForm.vbAttachmentId = this.vbAttachmentId;
              } else {
                throw signResult.ErrorDetail
              }
            })
        }

        if(this.vbStep.signType === 2 && this.userDeptRole.signType === 'hsm'){
          submitForm = {...submitForm, hsmPassword2: this.form.hsmPassword2}
        }

        if(this.userDeptRole.signType === "" && this.isConfigSigning !== 1){
          this.isProcessing = true;
          vbOutgoingProcessService
            .ketThuc(submitForm, this.docId)
            .then(async response => {
              // if(this.vbStep.signType === constants.STEP_INFO_SIGN_TYPE.KI_SO && this.isConfigSigning){
              //   await this.signDoc()
              // }
              this.$message({
                message: "Ký duyệt văn bản thành công",
                type: "success"
              });
              this.isProcessing = false;
              EventBus.$emit(this.parentRoute, {});
              this.$emit("success", {vbOutgoingProcess: response.data});
              EventBus.$emit('loadCounting', '');
              this.isOpenDocOutKetThucDialog = false;
            })
            .catch(error => {
              this.commonHandleRequestError(error);
              this.isProcessing = false;
            });
        }else if(this.userDeptRole.signType === "" ){
          this.notify(
            "Lỗi",
            "Ký số thất bại, vui lòng ký lại",
            "error",
            3000
          );
        }else {
          let isFormValid = true;
          await this.$refs.form.validate(valid => {
            if (!valid) {
              this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
              isFormValid = false;
            }
          })

          if (!isFormValid) return;

          this.isProcessing = true;
          vbOutgoingProcessService
            .ketThuc(submitForm, this.docId)
            .then(async response => {
              // if(this.vbStep.signType === constants.STEP_INFO_SIGN_TYPE.KI_SO && this.isConfigSigning){
              //   await this.signDoc()
              // }
              this.$message({
                message: "Ký duyệt văn bản thành công",
                type: "success"
              });
              this.isProcessing = false;
              EventBus.$emit(this.parentRoute, {});
              this.$emit("success", {vbOutgoingProcess: response.data});
              EventBus.$emit('loadCounting', '');
              this.isOpenDocOutKetThucDialog = false;
            })
            .catch(error => {
              this.commonHandleRequestError(error);
              this.isProcessing = false;
            });
        }
      },

      signDoc(){
        let userId;
        let docId = this.vbOutgoingProcess.docId;
        Promise.resolve(userService.get()).then(rs => {
          userId = rs.data.id;
          //Lấy ra file vừa ký mới nhất
          signingLocationUserService.getLatestSignedFile(docId).then(response => {
            this.vbAttachment = response.data
            if (this.vbAttachment.signedDocId){
              //Lấy ra danh sách chữ ký và cị trí ký của người dùng hiện tại
              signingLocationUserService.findAllLocationByUserIdAndDocId(userId, docId).then(async rs1 => {
                if (rs1.data.length > 0) {
                  //lấy ra token và link file
                  signingLocationUserService.getFileInputStream(this.vbAttachment.signedDocId).then(async rs2 => {
                    const base64Prefix = "data:application/pdf;base64,";
                    let base64String = base64Prefix + rs2.data;
                    await fetch(base64String).then(async res => {
                      await res.blob().then( async blob => {
                        //Thêm ảnh chữ ký theo vị trí ký đã lưu sẵn
                        let pdfFileBytes = await save(blob, rs1.data, userId)
                        let base64Converted = this.convertBytesToBase64(pdfFileBytes);
                        let formReplaceFile = {
                          attachmentId: this.vbAttachment.id,
                          signedDocId: this.vbAttachment.signedDocId,
                          objectId: docId,
                          fileBase64: base64Converted
                        }
                        //Thay file mới nhất bằng file vừa thêm chữ ký
                        await signingLocationUserService
                          .replaceSignedFile(formReplaceFile).then(() => {
                          })
                      });
                    });
                  })

                }
              })
            }
          });
        });
      },

      convertBytesToBase64(pdfFileBytes){
        let binaryString = '';
        pdfFileBytes.forEach(byte => {
          binaryString += String.fromCharCode(byte);
        });
        return btoa(binaryString);
      },
    }
  };
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/components/DocOutKetThuc.vue